// extracted by mini-css-extract-plugin
module.exports = {"responsiveButtons":"style__responsiveButtons__s0LKw"};